import { render } from "./Validation.vue?vue&type=template&id=640e03b8&scoped=true"
import script from "./Validation.vue?vue&type=script&lang=js"
export * from "./Validation.vue?vue&type=script&lang=js"

import "./Validation.vue?vue&type=style&index=0&id=640e03b8&scoped=true&lang=css"
import "./Validation.vue?vue&type=style&index=1&id=640e03b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640e03b8"]])

export default __exports__